import { useState, useEffect } from "react";
import { Button, Box, TextField } from "@mui/material";
import { UseProductMaterial } from "./UseProductMaterial";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

function EditProductMaterial(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const { getMaterialByID, validate, updateMaterial } = UseProductMaterial();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (location.state && location.state.id) {
      getMaterialByID(location.state.id, (materialRes) => {
        setState(materialRes);
      });
    }
  }, []);

  const [state, setState] = useState({
    id: undefined,
    name: undefined,
    enName: undefined,
  });

  const [errorState, setErrorState] = useState({
    name: false,
    enName: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/productmaterial" },
          { name: "ویرایش جنس محصول", url: "/productmaterial/editmaterial" },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            fullWidth
            value={state.name ? state.name : ""}
            error={errorState.name}
            label="نام "
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, name: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box
          gridColumn={isSmall ? "span 12" : "span 3"}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => {
              if (validate(state, setErrorState) == 200) {
                setProgress(true);
                updateMaterial(state, () => {
                  navigate("/productmaterial", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              navigate("/productmaterial", {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}

export default EditProductMaterial;
